import { DataFetchWrapper } from "@tfg/ui"

import { FAQContent } from "~/pages/Brand/FAQ/FAQContent.tsx"
import { useFAQQuery } from "~/pages/Brand/FAQ/hooks.ts"

export const SupplierFAQ = () => {
  const faqQuery = useFAQQuery()

  return (
    <DataFetchWrapper query={faqQuery}>
      {({ data }) => (
        <FAQContent faqs={data.filter((faq) => faq.category === "SUPPLIERS")} />
      )}
    </DataFetchWrapper>
  )
}
